import { OutboundFreight } from "kinnect-models";
import { KActionDialog } from "kinnect-general";

export default {
	name: "OutboundFreightDeleteDialog",

	props: {
		...KActionDialog.options.props,

		confirmButtonColor: {
			...KActionDialog.options.props.confirmButtonColor,
			default: "error"
		},

		confirmButtonText: {
			...KActionDialog.options.props.confirmButtonText,
			default: "Delete"
		},

		item: {
			required: true,
			type: OutboundFreight
		},

		title: {
			...KActionDialog.options.props.title,
			default: "Delete Outbound Freight"
		}
	},

	render() {
		return <KActionDialog
			attrs={{
				...this.$props,
				loading: this.$wait.is( "delete outbound freight" )
			}}
			on={{ ...this.$listeners }}
			scopedSlots={{
				default: () => "Are you sure you want to delete this outbound freight?",

				...this.$scopedSlots
			}}
		></KActionDialog>;
	}
};
